import Router from 'next/router';
import React, { createContext } from 'react';
import { getAuthFromContext, SignUpProfile } from '@auth/business/auth.utils';
import { SignUpLayout } from '@auth/components/SignUpLayout/SignUpLayout.component';
import { defaultNamespaces } from '@utils/strings';
import { castUrlParamToString, redirect, urlEnum } from '@utils/url';
import { PlcNextPage, PlcNextPageContext, PlcPageContextProps } from 'features/business/app.types';

type PageProps = {
  defaultProfile: SignUpProfile | undefined;
};

export const SignUpContext = createContext<PlcPageContextProps<PageProps>>({
  defaultProfile: { isValidating: false },
});

const Inscription: PlcNextPage<PageProps> = ({ defaultProfile }) => {
  return (
    <SignUpContext.Provider value={{ defaultProfile: { data: defaultProfile, isValidating: false } }}>
      <SignUpLayout />
    </SignUpContext.Provider>
  );
};

Inscription.getInitialProps = async (ctx: PlcNextPageContext) => {
  const { profil } = ctx.query;
  const defaultProfile = castUrlParamToString(profil) as SignUpProfile;
  const { isAuthenticated } = getAuthFromContext(ctx);
  const pageDefaultState = {
    defaultProfile: Object.values(SignUpProfile).includes(defaultProfile) ? defaultProfile : undefined,
    namespacesRequired: defaultNamespaces,
  };
  if (isAuthenticated) {
    redirect({
      Router,
      ctx,
      location: urlEnum.journal,
    });
    return pageDefaultState;
  }

  return pageDefaultState;
};

export default Inscription;
